// components
import LoginForm from "../../components/Home/LoginForm/LoginForm"
// styles
import styles from "./Landing.css"

const Landing = ({
    user,
    handleSignupOrLogin,
    updateMessage,
    message,
    setMessage
}) => {
    return (
        <>
            <main className="page-area">
                <div id="landing-area">
                    {user ?
                        <div>
                            <h1>
                                Hello, {user ? user.Role : 'please sign in'}
                            </h1>

                          
                        </div>                    
                    :
                        <div id="not-logged-in">
                            <h1 className="landing-header">
                                Hello, {user ? user.Role : 'please sign in'}
                            </h1>
                            <LoginForm
                                handleSignupOrLogin={handleSignupOrLogin}
                                updateMessage={updateMessage}
                                message={message}
                                setMessage={setMessage}
                            />
                        </div>
                    }
                </div>
            </main>
        </>
    )
}

export default Landing